import { render, staticRenderFns } from "./LabelComplex.vue?vue&type=template&id=51dd346d&scoped=true&"
import script from "./LabelComplex.vue?vue&type=script&lang=js&"
export * from "./LabelComplex.vue?vue&type=script&lang=js&"
import style0 from "./LabelComplex.vue?vue&type=style&index=0&id=51dd346d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dd346d",
  null
  
)

export default component.exports